import { createSlice } from '@reduxjs/toolkit';
import { PANEL_MODES } from '../editCourse/editCourseState';

const initialState = {
  menuSliderToggle: false,
  menuTocToggle: false,
  menuEditLeftToggle: false,
  menuEditLeftMode: PANEL_MODES.TOC,
  menuEditRightToggle: false,
  layoutOrganizerToggle: false,
  editRightPanelMode: 'module',
  notesSliderToggle: false,
  incarnateModal: false,
  loginModal: false,
};

const globalUiSlice = createSlice({
  name: 'globalUi',
  initialState,
  reducers: {
    setMenuSliderToggle: (state, action) => {
      state.menuSliderToggle = !!action.payload;
    },
    setMenuTocToggle: (state, action) => {
      state.menuTocToggle = !!action.payload;
    },
    setMenuEditLeftToggle: (state, action) => {
      state.menuEditLeftToggle = !!action.payload;
    },
    setMenuEditLeftMode: (state, action) => {
      const validModes = Object.values(PANEL_MODES);
      if (validModes.includes(action.payload)) {
        state.menuEditLeftMode = action.payload;
      }
    },
    setMenuEditRightToggle: (state, action) => {
      state.menuEditRightToggle = !!action.payload;
    },
    setLayoutOrganizerToggle: (state, action) => {
      state.layoutOrganizerToggle = !!action.payload;
    },
    setEditRightPanelMode: (state, action) => {
      state.editRightPanelMode = action.payload || 'module';
    },
    setNotesSliderToggle: (state, action) => {
      state.notesSliderToggle = !!action.payload;
    },
    setIncarnateModal: (state, action) => {
      state.incarnateModal = !!action.payload;
    },
    setLoginModal: (state, action) => {
      state.loginModal = !!action.payload;
    },
  },
});

export const {
  setMenuSliderToggle,
  setMenuTocToggle,
  setMenuEditLeftToggle,
  setMenuEditLeftMode,
  setMenuEditRightToggle,
  setLayoutOrganizerToggle,
  setEditRightPanelMode,
  setNotesSliderToggle,
  setIncarnateModal,
  setLoginModal,
} = globalUiSlice.actions;

export default globalUiSlice.reducer;
